
import {
  defineComponent
} from 'vue';

export default defineComponent({
  name: 'MyRepos',
  props: {
    header: {
      type: String,
    }
  },
  setup() {
    return {};
  },
});
